<template>
  <div>
    <Modal
      :value="showRefund"
      :title="title"
      :width="title==='信息补录' ? 500 : 900"
      @on-visible-change="(status)=>{$emit('visibleChange',status)}">
      <div v-show="title==='收退信息'">
        <Button 
          type="primary"
          @click="addOrder" 
          style="margin-bottom:10px"
          :disabled="addisable">添加收费信息</Button>
      </div>
      <Table v-show="title==='收退信息'" :columns="orderColumns" :data="chargeObj.OrderList"></Table>
      <Table v-show="title==='发票信息'" :columns="billColumns" :data="billList"></Table>
      <div v-show="title==='信息补录'">
        <Tabs :value="tabView" size="small">
          <TabPane label="服务费信息" name="service" style="margin-top: 10px">
            <p>
              <span class="label">金额(元)：</span>
              <Input v-model="messageForm.chargeForm.DAmount" style="width: 260px"></Input>
            </p>
            <p style="margin-top: 15px">
              <span class="label">支付时间：</span>
              <DatePicker type="datetime" v-model="messageForm.chargeForm.PayTime" style="width: 260px"></DatePicker>
            </p>
          </TabPane>
          <TabPane label="订单信息" name="order" style="margin-top: 10px">
            <p>
              <span class="label">开票公司名称：</span>
              <Select
                v-model="messageForm.orderForm.XhfCompanyName" 
                style="width:300px" 
                :transfer="true" 
                @on-change="selectChange">
                <Option v-for="item in XhfCompanyOptions" :value="item.value" :key="item.label">{{ item.value }}</Option>
              </Select>
            </p>
            <p style="margin-top: 15px">
              <span class="label">支付方式：</span>
              <Select
                v-model="messageForm.orderForm.PayChannel" 
                style="width:300px" 
                :transfer="true">
                <Option v-for="item in PayOptions" :value="item.value" :key="item.label">{{ item.value }}</Option>
              </Select>
            </p>
          </TabPane>
          <TabPane label="发票信息" name="invoice" style="margin-top: 10px"></TabPane>
        </Tabs>
      </div>
      <div slot="footer">
        <Button type="primary" v-show="title==='信息补录'" @click="submit">保存</Button>
      </div>
    </Modal>
    <confirm-options
      ref="confirm"
      :showConfirm="showConfirm"
      :chargeObj="chargeObj"
      @searchEnroll="()=>{$emit('searchEnroll', '1')}"
      @closeModal="()=>{$emit('visibleChange', false)}"
      @visibleChange="(val)=>{showConfirm=val}">
    </confirm-options>
    <!-- 缴费确认弹窗 -->
    <Modal v-model="paymentModal" width="600" title="缴费确认">
      <Row>
        <Col span="12" ><span style="font-weight:700">项目包组：</span>{{chargeObj.Title}}</Col>
        <Col span="12"><span style="font-weight:700">成交供应商：</span>{{chargeObj.CompanyName}}</Col>
      </Row>
      <Row style="margin-top:10px">
        <Col span="12" ><span style="font-weight:700">待缴金额：</span>{{chargeObj.Amount}}元</Col>
        <Col span="12"><span style="font-weight:700">银行账号：</span>{{PayCheckList.Account}}</Col>
      </Row>
      <Row style="margin-top:10px">
        <Col span="12" ><span style="font-weight:700">电子回单：</span>
          <span style="color:#2d8cf0;text-decoration:underline;cursor:pointer" @click="downLoad">
            {{PayCheckList.FileName}}
          </span>
        </Col>
        <Col span="12"><span style="font-weight:700">提交日期：</span>
          {{PayCheckList.AddTime ? PayCheckList.AddTime.slice(0,10) : ''}}
        </Col>
      </Row>
      <div slot="footer">
        <Button type="error" @click="rejectVisible=true;paymentModal=false;PayCheckList.Items=''">退回</Button>
        <Button type="primary" @click="paymentConfirm">确认</Button>
      </div>
    </Modal>
    <!-- 缴费退回 -->
    <Modal v-model="rejectVisible" title="退回申请" width="400" @on-ok="paymentRefuse">
      <Row :gutter="10">
        <Col span="5" style="text-align:right"><span style="color:red">*</span> 退回原因</Col>
        <Col span="18"><textarea v-model="PayCheckList.Items" class="rejectTextarea"></textarea></Col>
      </Row>
      <Row :gutter="10" style="margin-top:10px">
        <Col span="5" style="text-align:right">附件</Col>
        <Col span="18">
        <Upload :data="uploadFileInit.extradata" action="https://clneiwang.oss-cn-shenzhen.aliyuncs.com" :before-upload="handleBeforeUpload">
          <Button type="ghost" icon="ios-cloud-upload-outline" size="small">上传</Button>
        </Upload>
        </Col>
      </Row>
    </Modal>
  </div>
</template>
<script>
import axios from 'axios'
import qs from "qs"
import confirmOptions from './confirmOptions'
import { fileUtil } from '@/lib/abpfile'

export default {
  props: {
    title: String,
    showRefund: Boolean
  },
  components: {
    confirmOptions
  },
  computed: {
    user() {
      return this.$store.state.session.user
    },
    editPermission() {
      // 发票号码修改权限
      let a = this.$store.getters["session/hasRoles"]("WX_分公司财务助理")
      let b = this.$store.getters["session/hasRoles"]("WX_总部财务助理")
      let c = this.$store.getters["session/hasRoles"]("分公司财务助理")
      let d = this.$store.getters["session/hasRoles"]("总部财务助理")
      let e = this.$store.getters["session/hasRoles"]("总部财务负责人")
      return a || b || c || d || e
    }
  },
  data() {
    return {
      // baseUrl: 'http://www.choicelink.cn:8888',  // 接口url开头
      baseUrl: 'http://medical.chinapsp.cn:8888',  // 接口url开头
      chargeObj: {},
      billList: [],
      orderColumns: [
        {
          title: '订单编号',
          key: 'OrderNo',
          width: 130
        },
        {
          title: '金额',
          width: 100,
          render: (h,params) => {
            if (params.row.OrderAmountTotal) {
              return h('div', `${params.row.OrderAmountTotal}元`)
            }
            return h('div', '未确认收款')
          }
        },
        {
          title: '支付时间',
          key: 'PayTime',
          width: 120,
          render: (h, params) => {
            return params.row.PayTime ? h('div', params.row.PayTime.split('T')[0]) : h('div', '未支付')
          }
        },
        {
          title: '支付方式',
          key: 'PayChannel',
          width: 120,
          render: (h, params) => {
            return params.row.PayChannel ? h('div', params.row.PayChannel) : h('div', '未支付')
          }
        },
        {
          title: '状态',
          key: 'OrderStatus',
          width: 110,
          render: (h, params) => {
            if (params.row.PayChannel == '对公支付') {
              switch (this.chargeObj.AuditStatus) {
                case '1': return h('div', '已确认');break
                case '2': return h('div', '已退回');break
                default: return h('div', '待确认')
              }
            } else {
              switch (params.row.OrderStatus) {
                case '0':
                  return h('div', '红冲订单')
                break
                case '1':
                  return h('div', '待支付')
                break
                case '2':
                  return h('div', '未开票已支付')
                break
                case '3':
                  return h('div', '已开票已支付')
                break
                case '4':
                  return h('div', ' 已红冲或已退款')
                break
                case '5':
                  return h('div', ' 已开票未收款')
                break
              }
            }
          }
        },
        {
          title: '操作',
          width: 286,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: params.row.PayChannel == '对公支付' ? this.chargeObj.AuditStatus!=='0' : this.chargeObj.Status == '2'? false : !(params.row.OrderStatus === '1' || params.row.OrderStatus === '5')
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    if (params.row.PayChannel == '对公支付') {
                      this.paymentModal = true
                      this.currentOrder = params.row
                    } else {
                      this.showConfirm = true
                      this.$refs.confirm.init('确认收款', this.chargeObj, this.UserCompanyOptions, this.XhfCompanyOptions, params.row)
                    }
                  }
                }
              }, '确认收款'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: this.chargeObj.Status == '2' ? true : !(params.row.OrderStatus === '2' || params.row.OrderStatus === '3')
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Message.warning({
                      content: '请确认支付方式与收款时间',
                      duration: 4
                    })
                    this.showConfirm = true
                    this.$refs.confirm.init('确认退款', this.chargeObj, this.UserCompanyOptions, this.XhfCompanyOptions, params.row)
                  }
                }
              }, '确认退款'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: params.row.OrderStatus === '0'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    axios.get(`${this.baseUrl}/AgentApi/Orders/PSPOrdersObj?page=1&rows=10&ServiceChargeId=` + params.row.ServiceChargeId).then(res => {
                      let order = res.data.rows
                      order = order.filter(item => {
                        return item.OrderNo === params.row.OrderNo
                      })
                      // 未开过发票
                      if (order[0].FinancialInvoices.length === 0) {
                        this.showConfirm = true
                        this.$refs.confirm.init('开票(白票)', params.row, this.UserCompanyOptions, this.XhfCompanyOptions)
                      } else {
                        this.$Modal.confirm({
                            title: '开票确认',
                            content: '<p>该订单已开发票，是否要继续开票？</p>',
                            onOk: () => {
                              this.showConfirm = true
                              this.$refs.confirm.init('开票(白票)', params.row, this.UserCompanyOptions, this.XhfCompanyOptions)
                            },
                            onCancel: () => {}
                        })
                      }
                    })
                  }
                }
              }, '开票'),
              h('Button', {
                props: {
                  size: 'small',
                  disabled: this.chargeObj.Status == '2'? false : !(params.row.OrderStatus === '1' || params.row.OrderStatus === '5')
                },
                on: {
                  click: () => {
                    this.showConfirm = true
                    this.$refs.confirm.init('确认收款', this.chargeObj, this.UserCompanyOptions, this.XhfCompanyOptions, params.row)
                  }
                }
              }, '手动录入'),
            ]);
          }
        }
      ],
      billColumns: [
        {
          title: '发票号码',
          width: 110,
          key: 'InvoiceHm',
          render: (h,params) => {
            if (this.editPermission && params.row.InputMode !== '电子普通发票') {
              return h('Input', {
                props: {
                  value: params.row.InvoiceHm
                },
                on: {
                  input: (e) => {
                    this.messageForm.orderInvoiceForm.Id = params.row.Id;
                    this.messageForm.orderInvoiceForm.InvoiceHm = e;
                  },
                  'on-blur': () => {
                    let num = this.messageForm.orderInvoiceForm.InvoiceHm
                    if (num && num !== params.row.InvoiceHm) {
                      this.$Modal.confirm({
                        title: '发票号码修改',
                        content: `<p>确定要修改该发票号码为：${num}吗？</p>`,
                        onOk: () => {
                          // 修改发票号码
                          axios.post(`${this.baseUrl}/AgentApi/Orders/UPOrderInvoice`, qs.stringify(this.messageForm.orderInvoiceForm),{
                            headers: {
                              "Content-Type": "application/x-www-form-urlencoded"
                            }
                          }).then(res => {
                            this.$Message.success('修改成功！')
                          })
                        },
                        onCancel: () => {
                          this.messageForm.orderInvoiceForm.InvoiceHm = ''
                          this.getList(this.chargeObj)
                        }
                      });
                    }
                  }
                },
              })
            } else {
              return h('div', params.row.InvoiceHm)
            }
          }
        },
        {
          title: '订单号',
          width: 170,
          key: 'orderNum',
          render: (h,params) => {
            if (params.row.InvoiceType == 1) {
              return h('div', params.row.orderNum)
              } else {
              return h('div', params.row.orderNum + '(红冲)')
            }
          }
        },
        {
          title: '类型',
          width: 96,
          key: 'InvoiceType',
          render: (h,params) => {
            if (params.row.InvoiceType == 1) {
              return h('div', '正票')
              } else {
              return h('div', '红票')
            }
          }
        },
        {
          title: '开票人',
          width: 90,
          key: 'Kpr'
        },
        {
          title: '金额',
          width: 100,
          render: (h,params) => {
            if (params.row.InvoiceAmount) {
              return h('div', `${params.row.InvoiceAmount}元`)
            } else {
              return h('div', ``)
            }
          }
        },
        {
          title: '支付时间',
          width: 168,
          render: (h,params) => {
            return params.row.Kprq ? h('div', params.row.Kprq.replace('T', ' ')) : ''
          }
        },
        {
          title: '操作',
          width: 130,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: params.row.InvoiceStatus === 2 ? true : false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.showConfirm = true
                    let order = this.chargeObj.OrderList.filter(item => item.OrderNo === params.row.orderNum)
                    // 单纯红冲发票的，用正的id 发生退款的，就用负的订单id
                    if (order[0].RedOrderNo) {
                      order = this.chargeObj.OrderList.filter(item => item.OrderStatus == '0' && item.Id == order[0].RedOrderNo)
                    }
                    this.$refs.confirm.init('开票(红票)', params.row, this.UserCompanyOptions, this.XhfCompanyOptions, order[0])
                  }
                }
              }, '红冲发票')
            ]);
          }
        }
      ],
      UserCompanyOptions: '',
      tabView: 'service',  // TODO: 初始化标签页显示
      messageForm: {
        chargeForm: {
          Id: "",
          DAmount: "",
          PayTime:""
        },
        orderForm: {
          Id: "",
          XhfBankAccount: "",
          XhfBankName: "",
          XhfCompanyAddress: "",
          XhfCompanyName: "",
          XhfInvoiceTaxNo: "",
          XhfTelphone: "",
          PayChannel: ''
        },
        orderInvoiceForm: {
          Id: '',
          InvoiceHm: ''
        },
      },
      XhfCompanyOptions: [],
      showConfirm: false,
      addisable: true,
      PayOptions: [
        { value: '现金', label: '现金' },
        { value: '建设银行', label: '建设银行' },
        { value: '光大银行', label: '光大银行' },
        { value: '农业银行', label: '农业银行' },
        { value: '工商银行', label: '工商银行' },
        { value: '中国银行', label: '中国银行' },
        { value: '广发银行', label: '广发银行' },
        { value: 'POS', label: 'POS' },
        { value: '微信', label: '微信' },
        { value: '支付宝', label: '支付宝' }
      ],
      paymentModal: false,
      currentOrder: {},
      rejectVisible: false,
      PayCheckList: {
        Items: ''  // 退回原因
      },
      uploadFileInit: {
        action: '',
        extradata: {}
      },
      file: {}
    }
  },
  methods: {
    //获取所有销售方信息
    getAllXhfCompany(obj) {
      this.chargeObj = obj
      if(this.chargeObj.PayCheckList.length > 0) {
        this.PayCheckList = this.chargeObj.PayCheckList[0]
      }
      // 按OrderNo进行排序
      this.chargeObj.OrderList = this.chargeObj.OrderList.sort(function(a, b) {
        return a.OrderNo - b.OrderNo
      })
      this.addisable = true
      let validOrder = obj.OrderList.filter(item => !(item.OrderStatus == '0' || item.OrderStatus == '4'))
      // if (obj.OrderList.length == 0 || obj.OrderList[obj.OrderList.length - 1].OrderStatus === '0') {
      if (obj.OrderList.length == 0 || validOrder.length == 0) {
        this.addisable = false
      }
      this.XhfCompanyOptions = []
      axios.get(`${this.baseUrl}/AgentApi/Orders/PageChargesInfo?page=1&rows=40`).then(res => {
        if (res.status == 200) {
          res.data.rows.forEach(item => {
            this.XhfCompanyOptions.push({ value: item.CompanyName, label: item.Id })
            if (this.user.selectDistrict == item.Area) {
              this.UserCompanyOptions = item;
            }
          });
          this.getList(obj)
        }
      })
    },
    getList(obj) {
      this.billList = []
      axios.get(`${this.baseUrl}/AgentApi/Orders/PSPOrdersObj?page=1&rows=10&ServiceChargeId=` + obj.Id).then(res => {
        if (res.status == 200) {
          res.data.rows.forEach(item => {
            let orderNum = item.OrderNo
            if (item.FinancialInvoices.length !== 0) {
              item.FinancialInvoices.forEach(invoice => {
                this.$set(invoice, 'orderNum', orderNum)
                this.billList.push(invoice)
              })
              // 时间顺序排序
              this.billList.sort(function(a,b){
                return new Date(a.Kprq) - new Date(b.Kprq)
              })
              // if (this.billList[0].InvoiceStatus == 2) {
              //   this.messageForm.orderInvoiceForm.Id = this.billList[0].Id
              //   this.messageForm.orderInvoiceForm.InvoiceHm = this.billList[0].InvoiceHm
              // }
            }
          })
          if (this.title === '信息补录') {
            // 服务费信息
            this.messageForm.chargeForm.Id = obj.Id
            this.messageForm.chargeForm.DAmount = obj.DAmount
            this.messageForm.chargeForm.PayTime = obj.PayTime
            let list = this.chargeObj.OrderList
            if (list.length <= 1) {
              this.messageForm.orderForm.Id = list[0].Id
              this.messageForm.orderForm.XhfCompanyName = list[0].XhfCompanyName
              this.messageForm.orderForm.PayChannel = list[0].PayChannel
              this.getServiceChargeMessage(obj)
            } else {
              for (let i = list.length - 1; i > 0; i-- ) {
                if (!(list[i].OrderStatus === '0' || list[i].OrderStatus === '4')) {
                  // 订单信息
                  this.messageForm.orderForm.Id = list[i].Id
                  this.messageForm.orderForm.XhfCompanyName = list[i].XhfCompanyName
                  this.messageForm.orderForm.PayChannel = list[i].PayChannel
                  this.getServiceChargeMessage(obj)
                  break
                }
              }
            }
          }
        } else {
          this.$Message.error('数据请求失败！')
        }
      }).catch(err => {
          this.$Message.error(err)
          this.$Message.error('数据请求失败！')
      })
    },
    addOrder() {
      // 以第一条订单信息为主
      this.$Modal.confirm({
        title: '添加收费订单',
        content: '<p>确定要添加一条收费订单吗？</p>',
        onOk: () => {
          let param = this.chargeObj.OrderList[0]
          if(!param) {
            let date = new Date()
            let time = date.getTime()
            param = {
              OrderNo: `${time}`,  //订单编号（默认时间戳）
              PayStatus: this.chargeObj.Status,//支付状态
              RedOrderNo: '',  //红冲订单编号
              OrderStatus: '1',  //订单状态
              OrderAmountTotal: '',  //金额
              PayChannel: '',  //支付方式
              PayTime: '',  // 支付时间
              OrderType: '服务费',  //订单类型
              IsInvoice: 1,   // 是否开发票
              DebitAndCredit: '借',  //借/贷
              Area: this.chargeObj.Area,  //地区
              ServiceChargeId: this.chargeObj.Id,  //服务费表Id
              GhfBankAccount: '',  //供货方银行账号
              GhfBankName: '',  //供货方开户银行
              GhfCompanyName: '',  //供货方公司名称
              GhfInvoiceTaxNo: '',  //供货方统一信用代码
              GhfTelphone: '',  //供货方联系方式
              XhfBankAccount: '',  //销售方银行账号
              XhfBankName: '',  //销售方开户银行
              XhfCompanyName: '',  //销售方公司名称
              XhfInvoiceTaxNo: '',  //销售方统一信用代码
              XhfTelphone: '',  //销售方联系方式
              ProjectId: this.chargeObj.ProjectId,  //项目ID
              SupplierId: this.chargeObj.SupplierId,  //供应商ID
              GhfCompanyAddress: '',  //供货方地址
              XhfCompanyAddress: '',  //销售方地址
              DAmount: '',  // 实收服务费  必须手填
              Amount: this.chargeObj.Amount,  // 预计服务费
            }
          }
          this.$refs.confirm.init('添加收费订单', this.chargeObj, this.UserCompanyOptions, this.XhfCompanyOptions, param)
        },
        onCancel: () => {}
      })
    },
    // 信息补录
    getServiceChargeMessage(obj) {
      axios.get(`${this.baseUrl}/AgentApi/Orders/GetListChargesView`, {
        params: {
          "项目Id": obj["ProjectId"],
        }
      })
    },
    // 获取选中公司
    selectChange(val) {
      let arr = this.XhfCompanyOptions.filter(item => {
        return item.value === val
      })
      if (arr[0]) {
        axios.get(`${this.baseUrl}/AgentApi/Orders/PageChargesInfo?page=1&rows=40&Id=${arr[0].label}`).then(res => {
          if (res.status == 200) {
            let data = res.data.rows[0]
            this.messageForm.orderForm.XhfBankAccount = data.XhfBankAccount  //销售方银行账号
            this.messageForm.orderForm.XhfBankName = data.XhfBankName  //销售方开户银行
            this.messageForm.orderForm.XhfCompanyAddress = data.XhfCompanyAddress  //销售方地址
            this.messageForm.orderForm.XhfInvoiceTaxNo = data.XhfInvoiceTaxNo  //销售方统一信用代码
            this.messageForm.orderForm.XhfTelphone = data.XhfTelphone  //销售方联系方式
          }
        })
      }
    },
    paymentConfirm () {
      this.PayCheckList.Items = ''
      this.paymentModal = false
      this.showConfirm = true
      this.$refs.confirm.init('确认收款', this.chargeObj, this.UserCompanyOptions, this.XhfCompanyOptions, this.currentOrder)
    },
    paymentRefuse () {
      if(!this.PayCheckList.Items) {
        this.$Message.error('请填写退回原因')
        return
      }
      // 写入退回原因
      axios.post(`${this.baseUrl}/AgentApi/Orders/YCLPayCheck`, {
        "AccessKey":"RILKvl1ODfZhS3g7",
        "Action":"AddCheck",
        "Body": {
          "ServiceChargeId": this.chargeObj.Id,
          "OrderNo": this.currentOrder.OrderNo,
          "AddTime": new Date(),
          "Account": this.PayCheckList.Account,
          "FileUrl": this.PayCheckList.FileUrl,
          "FileName": this.PayCheckList.FileName,
          "Items": this.PayCheckList.Items,
          "Type":"服务费"
        }
      }).then(res => {
        // 更新服务费状态
        axios.post(`${this.baseUrl}/AgentApi/Orders/UPCharges`, qs.stringify({
          Id: this.chargeObj.Id,
          AuditStatus: '2',
          Status: '0'
        }),
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        }).then(res => {
          // 更新订单
          axios.post(this.baseUrl+'/AgentApi/Orders/UPOrders', qs.stringify({
            Id: this.currentOrder.Id,
            OrderStatus: '1',
            NpId: 1
          }))
          this.$Message.success('已退回')
          this.rejectVisible = false
          this.showConfirm = false
          this.file = {}
          this.$emit('visibleChange', false)
          this.$emit('searchEnroll', '1')
        })
      }).catch(err => {
        console.log(err)
        this.$Message.error('退回失败！')
      })
    },
    // 选择文件
    async handleBeforeUpload(file) {
			// 初始化文件上传
      this.uploadFileInit = await fileUtil.downloadInit(this.user.id, 1, 'clneiwang', 'serviceCharge/')
      this.$set(file, 'displayName', file.name)
      this.upLoad(file)
      return false
    },
    // 上传文件
    async upLoad(file) {
			let suffix = fileUtil.get_suffix(file.name)
			this.uploadFileInit.extradata.key = this.uploadFileInit.extradata.key + fileUtil.random_string(10) + suffix
			this.uploadFileInit.extradata['x:displayname'] = file.name
			this.$Spin.show()
			try {
				let uploadData = new FormData()
				for (let key in this.uploadFileInit.extradata) {
					uploadData.append(key, this.uploadFileInit.extradata[key])
				}
				uploadData.append('file', file)
				let rep = await axios.post(this.uploadFileInit.action, uploadData)
				this.$Spin.hide()
				if (rep.data.success) {
          this.file = rep.data.result
					this.$Message.success(`${file.displayName}上传成功`)
				} else {
					this.$Message.error(`${file.displayName}上传失败`)
				}
			} catch (err) {
				console.error(err)
				this.$Spin.hide()
				this.$Message.error(`${file.displayName}上传失败`)
			}
			return
    },
    downLoad() {
      window.open(this.PayCheckList.FileUrl)
    },
    async submit() {  // 信息补录
      let rep1 = await axios.post(`${this.baseUrl}/AgentApi/Orders/UPCharges`, qs.stringify(this.messageForm.chargeForm),{
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      let rep2 = await axios.post(`${this.baseUrl}/AgentApi/Orders/UPOrders`, qs.stringify(this.messageForm.orderForm),{
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      if (rep1.data && rep2.data) {
        this.$Message.success("保存成功")
        this.$emit('visibleChange', false)
        this.$emit('searchEnroll', '1')
      }
    }
  }
};
</script>
<style lang="less" scoped>
.label {
  display: inline-block;
  width: 100px;
}
.rejectTextarea {
  width: 100%;
  border:1px solid #ccc;
  border-radius: 6px;
  outline: none;
  padding: 6px 10px;
  height: 68px;
}
// TODO:下拉框太长啦
// .ivu-select-dropdown {
//   max-height: 108px;
// }
</style>
